import { values } from './enums'

const _enum = {
  Success: 0,
  NoChanges: 1,
  Failed: 2
}

export const closeTaskResult = {
  enumName: 'CloseTaskResult',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/closeTaskResult.js